<div class="order-widget">
    <div class="order-widget__container">
        <form name="form" class="form2" [formGroup]="form" (submit)="onSubmit()">
            <div class="ls-modal__body" style="min-height: 40px">
                <span *ngIf="item" class="ls-modal__header-title order-widget__title">
                    {{item.name}}
                </span>
                <ls-loader
                    *ngIf="nomenclaturePositionSubscription && !nomenclaturePositionSubscription.closed"></ls-loader>
                <div *ngIf="!(nomenclaturePositionSubscription && !nomenclaturePositionSubscription.closed)"
                     style="display: flex">
                    <div *ngIf="values?.f_image && showPhoto" class="order-widget__image-container">
                        <img style="max-height: 100%; max-width: 100%" *ngIf="values"
                             [src]="values.f_image">
                    </div>
                    <div class="order-widget__settings-container">
                        <ls-dynamic-widgets [widgets]="widgets" formControlName="item"></ls-dynamic-widgets>
                        <div class="ls-block__group" style="justify-content: flex-end; padding-bottom: 16px">
                            <div class="ls-block__item-control">
                                <button class="button button_tool" type="submit"
                                        [title]="crudOrderPosition.locker.isLockedByError? 'Сохранение недоступно из-за ошибки': ''"
                                        [class.lsu-loading]="isBusy()"
                                        [disabled]="!widgets.length || form.invalid || isBusy()">
                                    Добавить в заказ
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="hasOrders()" class="ls-content__section ls-block">
                <app-order-position-list class="ls-block__item"
                                            [orderInfo]="orderData"
                                            [editable]="true"
                                            [sortEnable]="true"
                                            (changed)="getOrder(orderData.id)">
                </app-order-position-list>
            </div>
        </form>
        <form [formGroup]="contactForm" class="ls-modal__body" (submit)="onSubmitContactForm()">
            <div *ngIf="showContactForm"  class="order-widget__contact-form">
                <div style="max-width: 800px">
                    <div class="grid__row">
                        <div class="ls-block__group">
                            <div class="ls-block__item-control select-container" style="flex: 1">
                                <ls-widget-tel
                                    class="select-input"
                                    placeholder="Телефон клиента"
                                    [formControl]="contactPhone"
                                ></ls-widget-tel>
                                <ng-container *ngIf="(subjContactItems | async) as contactItems">
                                    <ul tabindex="0" class="select__choices dropdown-menu show" *ngIf="contactItems.length">
                                        <li class="select__item-group" *ngFor="let person of contactItems">
                                            <div class="select__item dropdown-item" (click)="selectContactPhone(person.contactPhone)">
                                                {{phoneMask.mask(person.contactPhone)}}
                                            </div>
                                        </li>
                                    </ul>
                                </ng-container>
                            </div>
                            <div class="ls-block__item-control select-container" style="flex: 1">
                                <ls-widget-text
                                    class="select-input"
                                    placeholder="Имя клиента"
                                    [formControl]="contactPerson"
                                ></ls-widget-text>
                                <ng-container *ngIf="(subjContactItems | async) as contactItems">
                                    <ul tabindex="0" class="select__choices dropdown-menu show" *ngIf="contactItems.length">
                                        <li class="select__item-group" *ngFor="let person of contactItems">
                                            <div class="select__item dropdown-item" (click)="selectContactPerson(person.contactPerson)">
                                                {{person.contactPerson}}
                                            </div>
                                        </li>
                                    </ul>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                    <div class="grid__row">
                        <div class="grid__col grid__col_12 grid__col">
                            <ls-widget-text-area
                                placeholder="Комментарий к заказу"
                                formControlName="comment"
                                [limiters]="{txt_size: 1}"
                            ></ls-widget-text-area>
                        </div>
                    </div>
                </div>
                <div *ngIf="hasError()" style="color: #E44108" class="order-widget__error">
                    Заполните телефон
                </div>
            </div>
            <div *ngIf="showContactForm !== null"  class="order-widget__contact-buttons">
                <div style="display: flex">
                    <div *ngIf="hasOrders()"
                         class="url url--black url_strong url_space_right"
                         style="display: flex; align-items: center">
                        {{orderData.totalSum}}&nbsp;руб.
                    </div>
                    <app-share title="Копировать публичную ссылку" [link]="generateLink()" style="display: flex; align-items: center" *ngIf="hasOrders() && isSharable"
                               successMessage="Ссылка на публичную форму заказа скопирована в буфер обмена"
                               errorMessage="Ошибка в копировании публичной ссылки"></app-share>
                    <div *ngIf="!orderData.paidOnline && hasOrders() && isPayable">
                        <app-widget-payment-button
                            position='top'
                            [order]="locker.isLocked ? undefined : orderData"
                            [withIcon]="true"
                        ></app-widget-payment-button>
                    </div>
                    <button class="button button_tool" type="submit"
                            [disabled]="!hasOrders() || isBusy() || (showContactForm && hasError())"
                    >
                        <app-svg-icon-button svgId="mail" size="large" style="fill: white"></app-svg-icon-button>
                        Отправить заявку
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
